import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-selection-help',
  templateUrl: './selection-help.component.html',
  styleUrls: ['./selection-help.component.scss'],
})
export class SelectionHelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
